import { render, staticRenderFns } from "./checkOrderDetail.vue?vue&type=template&id=28882f44&scoped=true"
import script from "./checkOrderDetail.vue?vue&type=script&lang=js"
export * from "./checkOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./checkOrderDetail.vue?vue&type=style&index=0&id=28882f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28882f44",
  null
  
)

export default component.exports